<template>
  <div>
    <slot></slot>
    <div v-if="place.detail && place.detail.content" class="mt-1">
      <div class="text-btn_secondary" style="white-space:pre-wrap; word-wrap:break-word;" v-html="messageChange(place.detail.content)"></div>
    </div>
    <template v-if="place.benefit_contents && place.benefit_contents.length > 0">
      <div v-for="benefitContent in place.benefit_contents" class="place-gift mt-4" v-bind:key="benefitContent.label">
        <h3 class="font-bold">{{ benefitContent.label }}</h3>
        <div class="inline-block mt-2 p-2 bg-beige rounded text-sm">
          {{ benefitContent.text }}
        </div>
      </div>
    </template>
    <template v-else-if="place.benefits_content && place.benefits_content.length > 0">
      <div class="place-gift mt-4">
        <h3 class="font-bold">{{ $t('tour_pass_benefit') }}</h3>
        <div class="inline-block mt-2 p-2 bg-gray-light rounded text-sm">
          {{ place.benefits_content }}
        </div>
      </div>
    </template>
    <template v-if="place.links && place.links.length > 0">
      <div v-for="link in place.links" class="mt-4" v-bind:key="link.id">
        <div class="mt-4">
          <a :href="link.url" :target="link.target" class="button-primary block">
            <span>
              {{ link.label }}
            </span>
          </a>
        </div>
      </div>
    </template>
    <div class="mt-8 pb-2">
      <h3 class="section-title">{{ $t('tour_shop_information') }}</h3>
      <ul class="place-info">
        <template v-if="place.address && place.address.length > 0">
          <li v-if="place.zipcode && place.zipcode.length > 0">
            <span>{{ $t('tour_location') }}：</span>
            <span>〒{{ place.zipcode }} {{ place.address }}</span>
          </li>
          <li v-if="!place.zipcode || place.zipcode.length <= 0">
            <span>{{ $t('tour_location') }}：</span>
            <span>{{ place.address }}</span>
          </li>
        </template>
        <li v-if="place.tel && place.tel.length > 0">
          <span>{{ $t('tour_tel') }}：</span>
          <a :href="`tel:${ place.tel }`" class="inline-block text-link">
            <span class="mr-1">{{ place.tel }}</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" class="inline w-4">
              <path d="m556.47567 279.782859-.775371-.608385c-.356217-.279146-.875557-.216638-1.155136.139573l-2.039685 2.600512c-.279579.356211-.216641.875971.139576 1.155117l1.113606.873831c-.423864.646916-.986447 1.359339-1.721144 2.093596-.734698.734685-1.447132 1.297687-2.094059 1.721544l-.873845-1.113588c-.278723-.356211-.798919-.419147-1.154708-.139573l-2.600983 2.039651c-.355789.279146-.418726.799334-.139576 1.155117l.608395.775358c1.337526 1.337504 4.815351.028257 7.768269-2.924612 2.952491-2.952442 4.262188-6.430637 2.924661-7.768141" transform="translate(-544 -278)"/>
            </svg>
          </a>
        </li>
        <div v-if="place.phones && place.phones.length > 0">
          <li
            v-for="(phone, index) in place.phones"
            v-bind:key="index">
            <span>{{ $t('tour_tel') + String(index + 1) }}：</span>
            <a :href="`tel:${ phone.number }`" class="inline-block text-link">
              <span class="mr-1">{{ phone.number }}</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" class="inline w-4">
                <path d="m556.47567 279.782859-.775371-.608385c-.356217-.279146-.875557-.216638-1.155136.139573l-2.039685 2.600512c-.279579.356211-.216641.875971.139576 1.155117l1.113606.873831c-.423864.646916-.986447 1.359339-1.721144 2.093596-.734698.734685-1.447132 1.297687-2.094059 1.721544l-.873845-1.113588c-.278723-.356211-.798919-.419147-1.154708-.139573l-2.600983 2.039651c-.355789.279146-.418726.799334-.139576 1.155117l.608395.775358c1.337526 1.337504 4.815351.028257 7.768269-2.924612 2.952491-2.952442 4.262188-6.430637 2.924661-7.768141" transform="translate(-544 -278)"/>
              </svg>
            </a>
            <div v-if="phone.label && phone.label.length > 0">
              ({{ phone.label }})
            </div>
          </li>
        </div>
        <li v-if="place.hours && place.hours.length > 0" class="flex items-start">
          <span>{{ $t('tour_business_hours') }}：</span>
          <span>{{ place.hours }}</span>
        </li>
        <li v-if="place.holiday && place.holiday.length > 0">
          <span>{{ $t('tour_holiday') }}：</span>
          <span>{{ place.holiday }}</span>
        </li>
        <li v-if="place.access && place.access.length > 0">
          <span>{{ $t('tour_access') }}：</span>
          <span>{{ place.access }}</span>
        </li>
        <li v-if="place.url && place.url.length > 0" class="flex items-start">
          <span>{{ $t('tour_website') }}：</span>
          <span>
            <a :href="place.url" @click="sendEvent(place)" target="_blank" class="break-all text-link">{{ place.url }}</a>
          </span>
        </li>
        <li v-if="place.station && place.station.length > 0">
          <span>{{ $t('tour_station') }}：</span>
          <span>{{ place.station }}</span>
        </li>
        <li v-if="place.busstop && place.busstop.length > 0">
          <span>{{ $t('tour_busstop') }}：</span>
          <span>{{ place.busstop }}</span>
        </li>
        <li v-if="place.parking && place.parking.length > 0">
          <span>{{ $t('tour_parking') }}：</span>
          <span>{{ place.parking }}</span>
        </li>
        <div v-if="place.course_list && place.course_list.length > 0" class="mt-4">
          <span v-for="course in place.course_list" v-bind:key="course.id">
            <button class="container mx-auto button-primary block place-button" @click="openModelCourse(course,place)">
              {{ $t('tour_model_course')}}<br />({{course.title}})
            </button>
          </span>
        </div>
        <li>
          <p class="my-2">
            <a @click="copy" class="flex">
              <span class="block">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path d="m292 273v-16.3125l-4.6875-4.6875h-10.3125v21zm-2-14h-5v-5h1v4h4zm-1 17v-2h-13v-19h-2v21z" transform="translate(-271 -252)"/>
                </svg>
              </span>
              <span class="pl-2">{{ $t('tour_cory_share_url') }}</span>
            </a>
          </p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { event } from 'vue-gtag'
export default {
  props: {
    place: {
      type: Object,
      required: true
    }
  },
  methods: {
    openModelCourse: function (course,place) {
      event('モデルコース詳細',{course_id:course.id,course_name:course.title,poi_name:place.shop_name})                    
      this.$router.push({ name: 'modelCourse', query: { course: course.id }, params: { lang: this.$store.getters['user/getLang'] } })
    },
    messageChange: function (message) {
      return message.replaceAll('&lt;', '<').replaceAll('&gt;', '>').replace(/\\n/g, '<br />')
    },
    copy: function () {
      this.$alert({ message: this.$t('tour_copied_message') })
      this.copyTextToClipboard(location.href.substring(0, location.href.indexOf('/#/') + 3) + 'ja/' + this.place.poi_id);
    },
    copyTextToClipboard: function (text) {
      var doc = document.createElement("textarea");
      doc.textContent = text;
      var body = document.getElementsByTagName("body")[0];
      body.appendChild(doc);
      doc.select();
      var ret = document.execCommand('copy');
      body.removeChild(doc);
      return ret;
    },
    sendEvent: function (place) {
      event("HP遷移", {
        hp_id: place.poi_id,
        hp_name: place.shop_name
      });
    }
  }
}
</script>
